export default __webpack_public_path__ + "static/media/community.ef5cdea6.png";